"use strict"

import { FieldSelect } from '@/lib/core/components/data/form/FieldSelect'

export class FilterFieldSelect extends FieldSelect {
  #form
  #Logic
  #multilines
  #textFieldName
  #valueFieldName
  #value
  constructor({ form, register, fields, name, Logic, multilines, textFieldName, valueFieldName }) {
    super({ form, register, fields, name, Logic, originClass: FilterFieldSelect })
    this.#form = form
    this.#Logic = Logic
    this.#multilines = multilines
    this.#textFieldName = textFieldName
    this.#valueFieldName = valueFieldName
  }
  fillOptions({ registers }) {
    super.field.options = registers
      .filter(register => this.#getBase({ register })?.[this.#textFieldName] && this.#getBase({ register })?.[this.#valueFieldName])
      .map(register => {
        return { "option": { "text": this.#getBase({ register })?.[this.#textFieldName], "value": this.#getBase({ register })?.[this.#valueFieldName] } }
      })
      .removeDuplicatesObjects()
      .sort((a, b) => a.option.text?.localeCompare(b.option.text))
  }
  change({ value }) {
    this.#value = value
    this.#Logic[this.#Logic.name].filter()
  }
  filter({ registers }) {
    return this.#isEmpty()
      ? registers
      : registers.filter(register => this.#value.includes(this.#getBase({ register })?.[this.#valueFieldName]))
  }
  #getBase({ register }) { // eslint-disable-line
    return this.#multilines ? register[this.#multilines]?.getLast() : register
  }
  #isEmpty() { // eslint-disable-line
    return (!Array.isArray(this.#value) || this.#value.length == 0)
  }
}

export class DistritosFilterFieldSelect extends FilterFieldSelect {
  constructor({ form, register, fields, name = 'distritos', Logic }) {
    super({ form, register, fields, name, Logic, originClass: DistritosFilterFieldSelect, textFieldName: 'link_distrito', valueFieldName: 'distrito' })
  }
}

export class CorretoresFilterFieldSelect extends FilterFieldSelect {
  constructor({ form, register, fields, name = 'corretores', Logic }) {
    super({ form, register, fields, name, Logic, originClass: CorretoresFilterFieldSelect, multilines: 'ofertas', textFieldName: 'link_corretor', valueFieldName: 'corretor' })
  }
}

export class ZoneamentosFilterFieldSelect extends FilterFieldSelect {
  constructor({ form, register, fields, name = 'zoneamentos', Logic }) {
    super({ form, register, fields, name, Logic, originClass: ZoneamentosFilterFieldSelect, multilines: 'zoneamentos', textFieldName: 'nome', valueFieldName: '_id' })
  }
}

export class EstadosFilterFieldSelect extends FilterFieldSelect {
  constructor({ form, register, fields, name = 'estados', Logic }) {
    super({ form, register, fields, name, Logic, originClass: EstadosFilterFieldSelect, textFieldName: 'link_estado', valueFieldName: 'estado' })
  }
}

export class CidadesFilterFieldSelect extends FilterFieldSelect {
  constructor({ form, register, fields, name = 'cidades', Logic }) {
    super({ form, register, fields, name, Logic, originClass: CidadesFilterFieldSelect, textFieldName: 'link_cidade', valueFieldName: 'cidade' })
  }
}

export class StatusFilterFieldSelect extends FilterFieldSelect {
  constructor({ form, register, fields, name = 'status', Logic }) {
    super({ form, register, fields, name, Logic, originClass: CidadesFilterFieldSelect, textFieldName: 'link_status', valueFieldName: 'status' })
  }
}